import {Component} from 'react';
import h from 'react-hyperscript';
import './LoadingIndicator.scss';
import loader from 'Assets/loader.svg';
import Image from 'Components/Image/Image';

class LoadingIndicator extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      h('div', {
        className: `loading-indicator ${this.props.classNames}`,
      }, [
        h(Image, {
          src: loader,
          alt: 'Loading icon',
        }, null),
        this.props.title ? h('h4', {
          className: 'loading-title',
        }, this.props.title) : null,
        this.props.subtitle ? h('p', {
          className: 'loading-subtitle',
        }, this.props.subtitle) : null,
      ])
    );
  }
}

export default LoadingIndicator;
